import React from "react";
import "./Scorecard.scss";
import images from "../../../../../utilities/images/images";
import { isExactSummaryAvailable } from "../../../utils/isExactSummaryAvailable";

const Scorecard = ({ basicAnalytics }) => {
  if (!isExactSummaryAvailable(basicAnalytics)) {
    return null;
  }


  const {
    user_marks,
    total_marks,
    percentage,
    rank,
    total_candidates,
    accuracy,
    percentile,
    total_correct,
    total_incorrect,
    total_un_attempt,
    marked,
  } = basicAnalytics;

  return (
    <div className="scorecard">
      <div className="scorecard__left">
        <img src={images.cup} alt="cup" />
        <div className="score">
          {user_marks}/{total_marks}
        </div>
        <div className="scorecard__percentage">{percentage}%</div>
      </div>

      <div className="scorecard__right">

        <div className="scorecard__right__top">
          <div className="scorecard__right__top__metris">
            <div className="scorecard__right__top__metris__value">#{rank}</div>
            <div className="scorecard__right__top__metris__title">
              out of {total_candidates}
            </div>
          </div>

          <div className="scorecard__right__top__metris">
            <div className="scorecard__right__top__metris__value">
              {accuracy}%
            </div>
            <div className="scorecard__right__top__metris__title">Accuracy</div>
          </div>

          <div className="scorecard__right__top__metris">
            <div className="scorecard__right__top__metris__value">
              {percentile}%
            </div>
            <div className="scorecard__right__top__metris__title">Percentile</div>
          </div>
        </div>

        <div className="scorecard__right__bottom">
          <div className="scorecard__right__bottom__metris">
            <div className="scorecard__right__bottom__metris__value">
              {total_correct}
            </div>
            <div className="scorecard__right__bottom__metris__title">Correct</div>
          </div>

          <div className="scorecard__right__bottom__metris">
            <div className="scorecard__right__bottom__metris__value">
              {total_incorrect}
            </div>
            <div className="scorecard__right__bottom__metris__title">
              Incorrect
            </div>
          </div>

          <div className="scorecard__right__bottom__metris">
            <div className="scorecard__right__bottom__metris__value">
              {total_un_attempt}
            </div>
            <div className="scorecard__right__bottom__metris__title">
              Unattempted
            </div>
          </div>

          <div className="scorecard__right__bottom__metris">
            <div className="scorecard__right__bottom__metris__value">
              {marked}
            </div>
            <div className="scorecard__right__bottom__metris__title">
              Marked
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scorecard;
